<template>
  <div>
    <li v-for="link in links">
      <small>
        <a target="_blank" v-if="link.url" :href="baseurl + link.url">{{ link.title }}</a>
        <span v-if="!link.url">{{ link.title }}</span>
      </small>
    </li>
  </div>
</template>
<script>
export default {
  props: {
    links: {}
  },

  data() {
    return {
      baseurl: "https://www.cityofpae.sa.gov.au/?a="
    };
  }
};
</script>


// WEBPACK FOOTER //
// Modules/CityPlan/Resources/assets/js/components/SectionLinks.vue